import { Box, styled } from "@mui/material";

export const AttachmentListContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding-top: ${({ theme }) => theme.spacing(1)};
`;
